import type {} from '@angular/localize/init';
import type { TranslationConfig } from '../i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function promotionsRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@promotions-url-segment:promotions`;
  }
  return (appRoutesI18nCache['promotions'] ??= $localize`:url-segment@@promotions-url-segment:promotions`);
}
